/**
 * Page to show the reseller documents (e.g. invoices) funding sources.
 */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

import { Grid, Tab, Tabs } from '@mui/material';
import { Description, Receipt, RequestQuote } from '@mui/icons-material';

import AbEnvironment from '../auth/AbEnvironment';
import ResellerDocumentsBills from './ResellerDocumentsBills';
import ResellerDocumentsInvoices from './ResellerDocumentsInvoices';
import ResellerDocumentsNotices from './ResellerDocumentsNotices';

import PageTitle from '../ui/PageTitle';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  /*
  paper: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
    },
    textAlign: 'left',
    // color: theme.palette.text.secondary,
    maxWidth: 1154,
    marginTop: 16,
    marginBottom: 40
  },
  */
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    // color: theme.palette.text.secondary,
    maxWidth: 1200,
    marginTop: 16,
  }, 
  tabroot: {
    flexGrow: 1,
    margin: 0,
    maxWidth: 1200,
    //backgroundColor: theme.palette.primary.light,
    borderBottom: '2px solid #dedede'
  }
});

class ResellerDocuments extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tabValue: 0,
        }
    }

    componentDidMount() {
      // Is there something in local storage?
      let theValue = 0;
      let tabval = localStorage.getItem('documentsTabVal');
      if (tabval !== null) {
        theValue = parseInt(tabval, 10);
        this.setState({ tabValue: theValue });
      }
    }
  
    handleTabChange = (event, value) => {
        localStorage.setItem('documentsTabVal', value);
        this.setState({ tabValue: value });
    }
  
    render() {
        const { isAuthenticatedReseller, needAssent } = this.props.auth;
        const classes = this.props.classes;
  
        if (!isAuthenticatedReseller() || needAssent()) {
            return (
                <Redirect to='/home' />
            );
        } else {
            // Get document term.
            let documentTerm = this.props.auth.getDocumentTerm('documentName');
            if (documentTerm === 'documentName') {
                documentTerm = 'Document';
            }
            // Get invoice name.
            let invoiceTerm = this.props.auth.getDocumentTerm('documentsInvoiceType_3_Name');
            if (invoiceTerm === 'documentsInvoiceType_3_Name') {
                invoiceTerm = 'Invoice';
            }
            // Get bill name.
            let billTerm = this.props.auth.getDocumentTerm('documentsInvoiceType_0_Name');
            if (billTerm === 'documentsInvoiceType_0_Name') {
                billTerm = 'Bill';
            }
            // Get notice term
            let noticeTerm = 'Notice';

            let title = 'My ' + documentTerm.toLowerCase() + 's';
            let subTitle = invoiceTerm + 's, ' + billTerm.toLowerCase() + 's, and other ' + noticeTerm.toLowerCase() + 's';

            let invoicesTab = invoiceTerm + 's';
            let billsTab    = billTerm + 's';
            let noticesTab  = noticeTerm + 's';

            let acctId = abEnvironment.getUserAttribute("a_id");

            return (
                <React.Fragment>
                    <PageTitle title={title} subtitle={subTitle}/>
                    <Paper className={classes.paper}>

                        <Grid container spacing={0} direction="row" justifyContent="space-around">
                            <Grid item xs={12}>
                                <Tabs
                                    value={this.state.tabValue}
                                    onChange={this.handleTabChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="fullWidth"
                                    scrollButtons="auto"
                                    classes={{root: classes.tabroot, scrollButtons: classes.tabScrollButton}}
                                >
                                    <Tab label={invoicesTab} icon={<RequestQuote />}
                                        classes={{
                                            root: classes.tab,
                                            wrapper: classes.labelWrapped,
                                        }}
                                    />
                                    <Tab label={billsTab} icon={<Receipt />}
                                        classes={{
                                            root: classes.tab,
                                            wrapper: classes.labelWrapped,
                                        }}
                                    />
                                    <Tab label={noticesTab} icon={<Description />}
                                        classes={{
                                            root: classes.tab,
                                            wrapper: classes.labelWrapped,
                                        }}
                                    />
                                </Tabs>
                            </Grid>
                        </Grid>

                        {this.state.tabValue === 0 &&
                        <ResellerDocumentsInvoices accountId={acctId} auth={this.props.auth} history={this.props.history} />}

                        {this.state.tabValue === 1 &&
                        <ResellerDocumentsBills accountId={acctId} auth={this.props.auth} history={this.props.history} />}

                        {this.state.tabValue === 2 &&
                        <ResellerDocumentsNotices accountId={acctId} auth={this.props.auth} history={this.props.history} />}

                    </Paper>

                </React.Fragment>
            );
        }
    }
}
  
ResellerDocuments.propTypes = {
    classes: PropTypes.object.isRequired,
};
      
export default withStyles(styleSheet)(ResellerDocuments);
  